import { FormikValues, useFormikContext } from 'formik';
import React from 'react';

import { Grupo, Rotulo } from '.';
import Ajuda from './Ajuda';

interface Props {
    ajuda?: string;
    altura?: string;
    name: string;
    rotulo?: string;
    semMargem?: boolean;
}

const CaixaDeTexto = ({ ajuda, altura = '150px', name, rotulo, semMargem = false }: Props): React.ReactElement =>
{
    const {
        errors,
        handleBlur,
        handleChange,
        touched,
        values,
    } = useFormikContext<FormikValues>();

    return (
        <Grupo semMargem={ semMargem } emLinha={ false }>
            <textarea
                name={ name }
                className={ `form-control ${ errors[name] && touched[name] && 'is-invalid' }` }
                onChange={ handleChange }
                onBlur={ handleBlur }
                value={ values[name] ?? '' }
                style={{ height: altura }}
                placeholder={ rotulo }
            />
            <React.Fragment>
                { rotulo && (
                    <Rotulo name={ name }>
                        { rotulo }
                    </Rotulo>
                ) }
            </React.Fragment>
            <React.Fragment>
                { ajuda && (
                    <Ajuda>{ ajuda }</Ajuda>
                ) }
            </React.Fragment>
            <div className="invalid-tooltip">
                { errors[name] && touched[name] && errors[name] }
            </div>
        </Grupo>
    );
}

export default CaixaDeTexto;
